import { render, staticRenderFns } from "./ButtonTip.vue?vue&type=template&id=bba68350"
import script from "./ButtonTip.vue?vue&type=script&lang=js"
export * from "./ButtonTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports